<script setup lang="ts">
import SidebarModule from "./SidebarModule.vue"
import { ref, defineProps, toRef, watch } from "vue"
import { graphql } from "~/utils/graphql"

const props = defineProps<{
  currentEnergy: number | null
  trackId: string
}>()

const energy = toRef(props, "currentEnergy")
watch(energy, newValue => {
  newEnergy.value = newValue
})
const newEnergy = ref(energy.value)
const isSaving = ref(false)

async function onEdit(newValue: string | null) {
  const parsed = newValue ? parseInt(newValue, 10) : null
  newEnergy.value = parsed !== null && !isNaN(parsed) ? Math.max(0, Math.min(100, parsed)) : null

  if (newEnergy.value === null) return

  isSaving.value = true

  await graphql(
    `
    mutation SaveEnergy($trackId: ID!, $energy: Int!) {
      setTrackEnergy(trackID: $trackId, energy: $energy) {
        id
        energy
      }
    }
  `,
    { trackId: props.trackId, energy: newEnergy.value }
  )

  isSaving.value = false
}
</script>

<template>
  <SidebarModule
    :value="energy ? String(energy) : null"
    label="Energy"
    input-type="number"
    @on-edit="onEdit"
  >
    <span v-if="newEnergy !== null" class="text-black dark:text-white" :class="{ 'text-zinc-400': isSaving }">
      {{ newEnergy }}%
    </span>
    <span v-else class="text-zinc-400">—</span>
  </SidebarModule>
</template>
